// Component catalog data for Force Motors Urbania
// Grid: 12 columns x 20 rows, each cell ~150mm

export const CATEGORIES = [
  { id: 'Seating', label: 'Seating', icon: 'armchair' },
  { id: 'Utility', label: 'Utility & Living', icon: 'utensils-crossed' },
  { id: 'Lifestyle', label: 'Lifestyle', icon: 'tent' },
  { id: 'Storage', label: 'Storage', icon: 'archive' },
  { id: 'Electronics', label: 'Electronics', icon: 'monitor' },
  { id: 'Body', label: 'Body Panels', icon: 'layout' },
  { id: 'Upholstery', label: 'Upholstery', icon: 'layers' },
];

export const CATEGORY_COLORS = {
  Seating: { bg: 'bg-violet-500/20', border: 'border-violet-500/40', text: 'text-violet-400', fill: '#8b5cf6' },
  Utility: { bg: 'bg-amber-500/20', border: 'border-amber-500/40', text: 'text-amber-400', fill: '#f59e0b' },
  Lifestyle: { bg: 'bg-emerald-500/20', border: 'border-emerald-500/40', text: 'text-emerald-400', fill: '#10b981' },
  Storage: { bg: 'bg-cyan-500/20', border: 'border-cyan-500/40', text: 'text-cyan-400', fill: '#06b6d4' },
  Electronics: { bg: 'bg-rose-500/20', border: 'border-rose-500/40', text: 'text-rose-400', fill: '#f43f5e' },
  Body: { bg: 'bg-slate-500/20', border: 'border-slate-500/40', text: 'text-slate-400', fill: '#64748b' },
  Upholstery: { bg: 'bg-pink-500/20', border: 'border-pink-500/40', text: 'text-pink-400', fill: '#ec4899' },
};

export const VEHICLE_SPECS = {
  name: 'Force Motors Urbania',
  gridCols: 12,
  gridRows: 20,
  cellSize: 40, // px per cell on screen
  interiorWidth: 1800, // mm
  interiorLength: 3000, // mm
  maxWeight: 500, // kg
  // Door zones (grid coordinates) - where components shouldn't be placed
  doorZones: [
    { x: 0, y: 8, w: 2, h: 4, label: 'Left Door' },
    { x: 10, y: 8, w: 2, h: 4, label: 'Right Door' },
  ],
  // Driver area (first 2 rows are driver area)
  driverZone: { x: 0, y: 0, w: 12, h: 2 },
};

export function formatPrice(price) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(price);
}
